<template>
  <div>
    <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
    <a class="is-paddingless is-marginless no-line-height is-hidden-mobile" href="/write-a-review"><img class="valentines-banner is-hidden-mobile" alt="Valentine's campaign" src="/static/img/valentines/v-banner-desktop-new.png" srcset="/static/img/valentines/v-banner-desktop-new.png 1x, /static/img/valentines/v-banner-desktop-new@2x.png 1.5x, /static/img/valentines/v-banner-desktop-new@2x.png 2x, /static/img/valentines/v-banner-desktop-new@3x.png 3x" /></a>
    <img class="valentines-banner is-hidden-tablet" alt="Valentine's campaign" src="/static/img/valentines/v-banner-mobile-new.png" srcset="/static/img/valentines/v-banner-mobile-new.png 1x, /static/img/valentines/v-banner-mobile-new@2x.png 1.5x, /static/img/valentines/v-banner-mobile-new@2x.png 2x, /static/img/valentines/v-banner-mobile-new@3x.png 3x" />
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title has-text-weight-bold has-text-centered">Learn from other people's experiences and make smarter choices</h1>
          <div class="search-holder has-text-centered">
            <business-search></business-search>
          </div>
        </div>
      </div>
    </section>
    <!-- COMPANIES -->
    <div class="container is-marginless companies">
      <!-- DESKTOP -->
      <div class="columns is-hidden-mobile is-hidden-tablet-only">
        <div class="column is-10-tablet is-offset-1-tablet is-10-desktop is-offset-1-desktop is-10-widescreen is-offset-1-widescreen is-8-fullhd is-offset-2-fullhd">
          <div class="level">
            <div class="level-item">
              <a href="/miway">
                <img src="/static/img/landing/miway-logo.png"
                     srcset="/static/img/landing/miway-logo@2x.png 2x"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/prime-meridian-direct">
                <img src="/static/img/landing/pmd_logo.png" width="95" height="95"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/dotsurecoza">
                <img class="rgb_logo" src="/static/img/landing/rgb_logo.png"
                     srcset="/static/img/landing/rgb_logo.png"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/mit-mak-motors">
                <img class="mmm-logo" src="/static/img/landing/mmm-logo.png"
                     srcset="/static/img/landing/mmm-logo.png 2x"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/wingfield-motors">
                <img src="/static/img/landing/wingfield_logo.png" width="150"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/ikhokha">
                <img src="/static/img/landing/ikhokha-logo.png"
                     srcset="/static/img/landing/ikhokha-logo@2x.png 2x"/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- TABLET -->
      <div class="columns is-hidden-mobile is-hidden-desktop">
        <div class="column is-10 is-offset-1">
          <div class="level">
            <div class="level-item">
              <a href="/miway">
                <img src="/static/img/landing/miway-logo.png"
                     srcset="/static/img/landing/miway-logo@2x.png 2x"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/prime-meridian-direct">
                <img src="/static/img/landing/pmd_logo.png" width="95" height="95"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/dotsurecoza">
                <img src="/static/img/landing/rgb_logo.png"
                     srcset="/static/img/landing/rgb_logo.png"/>
              </a>
            </div>
            <div class="level-item">
              <a href="/mit-mak-motors">
                <img class="mmm-logo" src="/static/img/landing/mmm-logo.png"
                     srcset="/static/img/landing/mmm-logo.png 2x"/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-hidden-mobile is-hidden-desktop">
        <div class="column is-6 is-offset-3">
          <div class="level">
            <div class="level-item">
              <a href="/wingfield-motors">
                <img src="/static/img/landing/wingfield_logo.png" />
              </a>
            </div>
            <div class="level-item">
              <a href="/ikhokha">
                <img src="/static/img/landing/ikhokha-logo.png"
                     srcset="/static/img/landing/ikhokha-logo@2x.png 2x"/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- MOBILE -->
      <div class="container outer-padding">
        <div class="columns level is-hidden-tablet is-mobile">
          <div class="column is-marginless">
            <div class="level-item">
              <a href="/miway">
                <img src="/static/img/landing/miway-logo.png"
                     srcset="/static/img/landing/miway-logo@2x.png 2x"/>
              </a>
            </div>
          </div>
          <div class="column is-marginless">
            <div class="level-item">
              <a href="/prime-meridian-direct">
                <img src="/static/img/landing/pmd_logo.png" width="95" height="95"/>
              </a>
            </div>
          </div>
          <div class="column is-marginless">
            <div class="level-item">
              <a href="/dotsurecoza">
                <img src="/static/img/landing/rgb_logo.png"
                     srcset="/static/img/landing/rgb_logo.png"/>
              </a>
            </div>
          </div>
        </div>
        <div class="columns level is-hidden-tablet is-mobile">
          <div class="column is-marginless">
            <div class="level-item">
              <a href="/mit-mak-motors">
                <img class="mmm-logo" src="/static/img/landing/mmm-logo.png"
                     srcset="/static/img/landing/mmm-logo.png 2x"/>
              </a>
            </div>
          </div>
          <div class="column is-marginless">
            <div class="level-item">
              <a href="/wingfield-motors">
                <img src="/static/img/landing/wingfield_logo.png" />
              </a>
            </div>
          </div>
          <div class="column is-marginless">
            <div class="level-item">
              <a href="/ikhokha">
                <img src="/static/img/landing/ikhokha-logo.png"
                     srcset="/static/img/landing/ikhokha-logo@2x.png 2x"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="!isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    </p>
    <p v-if="isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd"></ad>
    </p>
<!--    <leaderboard></leaderboard>-->
<!--    <leaderboard-mobile :force-narrow-ad="mobileAdNarrow"></leaderboard-mobile>-->
    <!-- FEATURED REVIEWS -->
    <section class="section featured-reviews">
      <p v-if="reviews_loading" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Loading reviews" /></p>
      <div v-if="!reviews_loading" class="columns is-multiline">
        <div v-for="(reviewItem, index) in featuredReviews" class="column is-full-tablet is-half-desktop" :ref="`reviewItem_${index}`">
          <review-card :custom-height="equalHeightStyle"
                       :author="reviewItem.author"
                       :author-id="reviewItem.author_id"
                       :author-avatar="reviewItem.authorAvatar"
                       :author-avatar-color="backgroundColors[index]"
                       :review-rating="reviewItem.review_rating"
                       :business="reviewItem.business_name"
                       :business-slug="reviewItem.business_slug"
                       :review-slug="reviewItem.permalink"
                       :review-title="reviewItem.review_title"
                       :review-blurb="reviewItem.review_content"
                       :review-date="reviewItem.created_at"></review-card>
        </div>
      </div>
      <p class="is-hidden-mobile has-text-weight-bold has-text-centered write-review-text">Have something to share?<router-link to="/write-a-review" class="button">WRITE YOUR REVIEW NOW</router-link></p>
      <p v-if="!isMobileAds" class="has-text-centered">
        <ad v-on:ad-loaded="updateAdCounter" :ad-object="thirdAd"></ad>
      </p>
      <p class="is-hidden-tablet has-text-weight-bold has-text-centered write-review-text">Have something to share?</p>
      <div class="container is-hidden-tablet">
        <router-link to="/write-a-review" class="button is-fullwidth">WRITE YOUR REVIEW NOW</router-link>
      </div>
      <p v-if="isMobileAds" class="has-text-centered">
        <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
      </p>
    </section>
    <industry-carousel v-on:industry-carousel-loaded="industriesHasLoaded"></industry-carousel>
  </div>
</template>
<script>
  import axios from 'axios'
  import BusinessSearch from '@/components/BusinessSearch'
  import FeaturedBusinesses from '@/mixins/featured_businesses'
  import ReviewCard from '@/components/ReviewCard'
  import Leaderboard from '@/components/Leaderboard'
  import LeaderboardMobile from '@/components/LeaderBoardMobile'
  import IndustryCarousel from '@/components/IndustryCarousel'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'

  export default {
    name: 'HomePage',
    metaInfo () {
      return {
        title: 'Home - Review Companies Online | Customer Service & Company Ratings | hellopeter.com'
      }
    },
    components: {
      BusinessSearch,
      ReviewCard,
      Leaderboard,
      LeaderboardMobile,
      IndustryCarousel,
      Ad
    },
    mixins: [FeaturedBusinesses, adsConfig],
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Home'
      })
      this.matchHeight()
      this.loadAds()
    },
    created () {
      this.getFeaturedReviews()
      // this.getTopBusinessesPerIndustry()
    },
    beforeDestroy () {
      clearInterval(this.interactionHandler)
    },
    data () {
      return {
        equalHeightSet: false,
        equalHeightStyle: '',
        intervalId: '',
        featuredReviews: [],
        reviews_loading: false,
        backgroundColors: [
          '#88397F',
          '#394B88',
          '#39887C',
          '#885A39',
          '#88397F',
          '#394B88',
          '#39887C',
          '#885A39'
        ],
        navigationEnabled: true,
        paginationEnabled: false,
        scrollPerPage: false,
        industriesLoaded: false,
        mobileAdNarrow: true
      }
    },
    methods: {
      matchHeight () {
        let intervalFunction = () => {
          if (!this.equalHeightSet) {
            const refOne = this.$refs.reviewItem_0
            const refTwo = this.$refs.reviewItem_1
            const refThree = this.$refs.reviewItem_2
            const refFour = this.$refs.reviewItem_3
            if (typeof refOne !== 'undefined' && typeof refTwo !== 'undefined' && typeof refThree !== 'undefined' && typeof refFour !== 'undefined') {
              const heightOne = refOne[0].clientHeight
              const heightTwo = refTwo[0].clientHeight
              const heightThree = refThree[0].clientHeight
              const heightFour = refFour[0].clientHeight
              const biggestNumber = Math.max(heightOne, heightTwo, heightThree, heightFour)
              this.equalHeightStyle = `height:${biggestNumber}px!important;`
              this.equalHeightSet = true
            }
          }
        }
        this.intervalId = setInterval(intervalFunction, 1000)
      },
      getFeaturedReviews () {
        this.reviews_loading = true
        axios.get('/consumer/featured-reviews')
          .then(({data}) => {
            this.featuredReviews = data
            this.reviews_loading = false
          })
          .catch(() => {
            this.reviews_loading = false
          })
      },
      industriesHasLoaded () {
        this.industriesLoaded = true
      }
    },
    computed: {
      industriesAndReviews () {
        const reviewLength = this.featuredReviews.length
        const industryLength = parseInt(this.industriesLoaded)
        return `${reviewLength},${industryLength}`
      }
    },
    watch: {
      industriesAndReviews () {
        window.prerenderReady = true
      }
    }
  }
</script>
<style scoped>

  h1.title {
    color: #ffffff;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    font-size: 2.4rem;
    margin-top: 10.2rem;
  }

  section.hero {
    background: url("/static/img/hero/hero-home-desktop@2x.jpg") no-repeat;
    background-size: cover;
    height: 600px;
  }

  .search-holder {
    max-width: 500px;
    margin: 3rem auto;
  }

  .featured-businesses {
    background-color: #F5F5F5;
  }
  .featured-businesses .container {
    max-width: 1000px;
  }

  .featured-businesses h1.title {
    color: #58595B;
    margin-top: 1rem;
    font-size: 1.9rem;
    margin-bottom: 3rem;
  }

  .section {
    padding: 1.5rem 1.5rem 3rem 1.5rem;
  }

  .featured-businesses > .container.is-hidden-mobile img {
    display: block;
    width: 100px;
    height: 100px;
    margin: 0 auto 0.5rem auto;
  }

  .featured-businesses > .container.is-hidden-tablet img {
    max-width: 30px;
  }

  .featured-businesses > .container.is-hidden-tablet p {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9rem;
    color: #58595B
  }

  .featured-businesses a {
    font-size: 1.1rem;
    color: #58595B;
  }

  .featured-reviews {
    width:100%;
    max-width: 1125px;
    margin: 20px auto 0 auto;
    padding-top: 0;
    padding-bottom: 0;
  }

  .featured-reviews > .columns > .column:nth-child(odd) {
    padding-left: 0;
  }

  .featured-reviews > .columns > .column:nth-child(even) {
    padding-right: 0;
  }

  .write-review-text {
    font-size: 1.9rem;
    color: #58595B;
    margin-top: 4rem;
  }

  .write-review-text > .button {
    font-size: 0.85rem;
    font-weight: normal;
    border-radius: 0;
    color: #58595B;
    padding: 1.3rem 2rem;
    border: 1px solid #58595B;
    margin-left: 2rem;
  }

  .is-hidden-tablet.write-review-text {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    margin-top: 2rem;
  }

  p.write-review-text + .container {
    padding: 0 1.2rem;
  }

  p.write-review-text + .container > .button {
    font-size: 0.85rem;
    border-radius: 0;
    color: #58595B;
    padding-top: 1.3rem;
    padding-bottom: 1.3rem;
    border: 1px solid #58595B;
  }

  .companies {
    background-color: #F5F5F5;
    width: 100%;
    max-width: 100%;
  }

  .rgb_logo {height: 50px;}
  .mmm-logo {height: 65px;}
  @media screen and (max-width: 1024px) {
    section.hero {
      background: url("/static/img/hero/hero-home-tablet@2x.jpg") no-repeat;
      background-size: cover;
    }

    h1.title {
      font-size: 2.3rem;
    }

    .featured-reviews > .columns > .column:nth-child(odd), .featured-reviews > .columns > .column:nth-child(even) {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }

  @media screen and (max-width: 767px) {
    section.hero {
      background: url("/static/img/hero/hero-home-mobile@2x.jpg") no-repeat;
      background-size: cover;
      height: 330px;
    }

    h1.title {
      font-size: 1.6rem;
      margin-top: 4rem;
      line-height: 2rem;
    }

    .search-holder {
      width: 300px;
      margin: 2rem auto;
    }

    .featured-businesses h1.title {
      margin-top: 0;
      font-size: 1.4rem;
    }

    .featured-reviews, .featured-reviews > .columns > .column:nth-child(odd), .featured-reviews > .columns > .column:nth-child(even) {
      padding-left: 0;
      padding-right: 0;
    }

    .featured-reviews > .columns > .column {
      padding-top: 0;
      padding-bottom: 0;
    }

    .featured-reviews > .columns > .column > .card {
      /*border-top: none;*/
    }

    .featured-reviews {
      padding-top: 0;
      padding-bottom: 0;
    }

    .companies {
      padding: 0.5rem 0.5rem 1rem 0.5rem;
      margin-bottom: 2rem!important;
    }

    .featured-reviews > .columns > .column:last-child > .card {
      border-bottom: 1px solid #C9C9C9;
    }
  }

  img.valentines-banner {
    width: 100%;
    margin-bottom: -6px;
  }

  .no-line-height {
    line-height: 0;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue